import { render } from "./petsintroductionComponent.vue?vue&type=template&id=38ed6a67&scoped=true"
import script from "./petsintroductionComponent.vue?vue&type=script&lang=js"
export * from "./petsintroductionComponent.vue?vue&type=script&lang=js"

import "./petsintroductionComponent.vue?vue&type=style&index=0&id=38ed6a67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ed6a67"]])

export default __exports__